// app/src/pages/ProPage.tsx
import React, { FC } from 'react';
import HomePageMobilePro from "../components/mobile/pro/HomePageMobilePro";
import { useMediaQuery } from 'react-responsive';
import { useScaleMobile } from "../contexts/ScaleContextMobile";
import { useScaleDesktop } from "../contexts/ScaleContextDesktop";
import HeaderMobilePro from "../components/mobile/pro/HeaderMobilePro";
import HeaderDesktopPro from "../components/desktop/pro/HeaderDesktopPro";
import HomePageDesktopPro from "../components/desktop/pro/HomePageDesktopPro";

const ProPage: FC = () => {
	const { scaleMobile } = useScaleMobile();
	const { scaleDesktop } = useScaleDesktop();

	const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

	
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'start',
				alignItems: 'center',
			}}
		>
			{isDesktop ? (
				<div
					style={{
						position: 'absolute',
						top: 0,
						color: '#323E48',
						transform: `scale(${scaleDesktop})`,
						transformOrigin: 'top',
						transition: 'transform 0.3s ease, padding 0.3s ease',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<HeaderDesktopPro />
					<HomePageDesktopPro />
				</div>
			) : (
				<div
					style={{
						color: '#323E48',
						width: 390,
						transform: `scale(${scaleMobile})`,
						transformOrigin: 'top',
						transition: 'transform 0.3s ease, padding 0.3s ease',
						overflow: 'auto',
					}}
				>
					<HeaderMobilePro />
					<HomePageMobilePro />
				</div>
			)}
		</div>
	);
};

export default ProPage;
